import React, { useState, useEffect } from "react";
import { Bell } from "lucide-react";
import { initPushNotifications, subscribeToPush, isPushSubscribed } from "@/lib/pushManager";
import { BACKEND_URL } from "@/lib/api";

const PUSH_DISMISS_KEY = "nc_push_prompt_dismissed";

export default function PushPrompt() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if permanently dismissed
    if (localStorage.getItem(PUSH_DISMISS_KEY)) return;

    const timer = setTimeout(async () => {
      // Check admin config
      try {
        const res = await fetch(`${BACKEND_URL}/api/marketing/push-prompt/config`);
        const cfg = await res.json();
        if (!cfg.enabled) return;
      } catch {
        // If config endpoint fails, default to showing
      }

      const ok = await initPushNotifications();
      if (ok && 'Notification' in window && Notification.permission === 'default') {
        const sub = await isPushSubscribed();
        if (!sub) setShow(true);
      }
    }, 10000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(PUSH_DISMISS_KEY, "1");
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-20 md:bottom-4 left-3 right-3 md:left-auto md:right-4 md:w-80 bg-white border border-gray-200 rounded-2xl shadow-xl p-4 z-40 animate-fade-in" data-testid="push-banner">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 bg-[#FFB800] rounded-xl flex items-center justify-center text-white flex-shrink-0">
          <Bell className="w-5 h-5" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm text-gray-900">Stay Updated</p>
          <p className="text-xs text-gray-500 mt-0.5">Get notified about deals, new arrivals & your orders.</p>
          <div className="flex gap-2 mt-3">
            <button onClick={async () => { await subscribeToPush(); setShow(false); localStorage.setItem(PUSH_DISMISS_KEY, "1"); }}
              className="px-4 py-2 bg-[#FFB800] text-white text-xs font-semibold rounded-lg hover:bg-[#16213e] transition-colors active:scale-95"
              data-testid="push-enable-btn">
              Enable
            </button>
            <button onClick={dismiss}
              className="px-3 py-2 text-xs text-gray-500 hover:text-gray-700 active:scale-95"
              data-testid="push-dismiss-btn">
              Not now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
